module.exports = __webpack_public_path__ + "static/media/206-gallery08.e96379bc.jpg";